import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const GiftLine: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0033 1.33533C11.476 1.33533 12.6699 2.52923 12.6699 4.00199C12.6699 4.48801 12.5399 4.94367 12.3127 5.33607L15.3366 5.33533V6.66864H14.0033V13.3353C14.0033 13.7035 13.7048 14.002 13.3366 14.002H2.66992C2.30173 14.002 2.00326 13.7035 2.00326 13.3353V6.66864H0.669922V5.33533L3.69377 5.33607C3.46661 4.94367 3.33659 4.48801 3.33659 4.00199C3.33659 2.52923 4.53049 1.33533 6.00325 1.33533C6.80007 1.33533 7.51527 1.6848 8.00387 2.23883C8.49127 1.6848 9.20647 1.33533 10.0033 1.33533ZM7.3366 6.66864H3.33659V12.6686H7.3366V6.66864ZM12.6699 6.66864H8.66993V12.6686H12.6699V6.66864ZM6.00325 2.66866C5.26687 2.66866 4.66992 3.26561 4.66992 4.00199C4.66992 4.7049 5.21384 5.28077 5.90375 5.33167L6.00325 5.33533H7.3366V4.00199C7.3366 3.33423 6.84573 2.78112 6.20511 2.68384L6.10277 2.67232L6.00325 2.66866ZM10.0033 2.66866C9.30033 2.66866 8.72447 3.21258 8.6736 3.90249L8.66993 4.00199V5.33533H10.0033C10.7061 5.33533 11.282 4.79141 11.3329 4.1015L11.3366 4.00199C11.3366 3.26561 10.7397 2.66866 10.0033 2.66866Z"
        fill={color}
      />
    </svg>
  );
};

export default GiftLine;
